import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=fdf5c4ba&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=fdf5c4ba&prod&lang=scss&scoped=true"
import style1 from "./Result.vue?vue&type=style&index=1&id=fdf5c4ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf5c4ba",
  null
  
)

export default component.exports